module.exports = __webpack_public_path__ + "d9e1ef0a70305e6bb574776c1727f354.png";